<template>
    <DropdownButton class="multi-select-dropdown" :is-left="isLeft" :keep-open-if-clicked-inside="true">
        <template v-slot:trigger>
            <button class="button">
                <span>{{ triggerText }}</span>
                <span class="icon">
                    <i class="fa fa-caret-down" />
                </span>
            </button>
        </template>
        <template v-slot:content>
            <div class="search-input mb-2">
                <input type="text" class="input" placeholder="Search" v-model="searchQuery" />
            </div>
            <div class="items-container" v-if="filteredItems.length > 0">
                <div
                    v-for="item in filteredItems"
                    :key="item.key"
                    class="single-item"
                    :class="{ 'is-selected': isSelected(item.key) }"
                    @click="toggleElement(item.key)"
                >
                    <slot name="item" :item="item">
                        {{ item.text }}
                    </slot>
                </div>
            </div>
            <div class="no-items" v-else-if="!!noContentMessage">
                {{ noContentMessage }}
            </div>
            <a class="clear-choices" @click="clearAll">
                <span class="icon">
                    <i class="fa fa-times" />
                </span>
                <span>{{ translate("common.clear_all_choices") }}</span>
            </a>
        </template>
    </DropdownButton>
</template>

<script>
    import DropdownButton from "./DropdownButton";
    import objectMatcher from "./objectMatcher";
    import translatorMixin from "./translatorMixin";

    export default {
        name: "multi-select-dropdown",
        components: { DropdownButton },
        mixins: [translatorMixin],
        /**
         * Each item: { icon: "icon (optional)", text: "", key: ""> }
         * Eg: { icon: "flag-icon flag-icon-pl", "text": "Poland", key: "PL"}
         */
        props: ["triggerText", "items", "modelValue", "isLeft", "noContentMessage"],
        data() {
            return {
                searchQuery: "",
                //Represents array of selected "keys".
                internalSelections: {},
            };
        },
        computed: {
            filteredItems() {
                return this.items.filter(item => {
                    return objectMatcher.matchString(this.searchQuery, item.text);
                });
            },
        },
        mounted() {
            this.modelValue.forEach(key => {
                this.internalSelections[key] = true;
            });
        },
        methods: {
            toggleElement(key) {
                this.internalSelections[key] = !this.internalSelections[key];

                const selectedKeys = Object.keys(this.internalSelections).filter(existingKey => {
                    return !!this.internalSelections[existingKey];
                });

                this.$emit("update:modelValue", selectedKeys);
            },
            isSelected(key) {
                return !!this.internalSelections[key];
            },
            clearAll() {
                this.internalSelections = {};
                this.$emit("update:modelValue", []);
            },
        },
    };
</script>

<style scoped></style>
